module.exports = __webpack_public_path__ + "img/logo.a48f86e5.png";